import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'components'
import { FaCheck } from 'react-icons/fa'

import { groupContext } from 'context'
import * as actionCreators from 'store/actions'

const Container = styled.div`
    background-color: var(--secondary-color);
    // width: var(--popout-width);
    width: fit-content;
    min-width: var(--popout-width);
    max-width: 17rem;
    font-size: var(--popout-font-size);
    padding: 0.5rem;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    margin-top: 0.5rem;
    box-shadow: var(--box-shadow);
    :focus{
        outline: none;
    }
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Wrapper = styled.div`
    border: ${props => `2px solid ${props.selected ? 'var(--focus-color)' : 'transparent'}`};
    border-radius: 5px;
`


const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    padding: 0 0 0 0.5rem;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
`

const Icon = styled.div`
    color: ${props => props.color || 'var(--secondary-accent-color)'};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
`

const Row = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1rem 3rem 1fr 1rem;
    grid-column-gap: 0.5rem;
    padding: 0.5rem 0.5rem;
    background-color: var(--secondary-color);
    border-radius: 5px;
    cursor: pointer;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Text = styled.div`
    font-weight: bold;
    font-size: 0.8rem;
`
const buttonStyle = {
    backgroundColor: 'var(--secondary-color)', 
    boxShadowColor: 'transparent',
    fontWeight: 'bold',
    margin: '0.1rem 0',
    justifyContent: 'flex-start',
    padding: '0.5rem'
}

const selectedStyle = {
    ...buttonStyle,
    backgroundColor: 'var(--focus-color)',
}

const GroupOptions = props => {
    const {
        pageID,
        closeHandler
    } = props;
    const debug = false;
    const dispatch = useDispatch()
    const uid = useSelector(state => state.auth.uid)
    const sessionId = useSelector(state => state.content.sessionId)
    const data = useSelector((state) => state.db.present.data && state.db.present.data.toJS())
    const page = data['pages'][pageID]
    const group = page['group']

    const onSelect = (option) => {
        let updatedPage = {...page}
        updatedPage['group'] = group === option ? null : option
        // closeHandler && closeHandler()
        debug && console.log('[GroupOptions]', {group: updatedPage['group'], updatedPage})
        dispatch(actionCreators.updatePage(updatedPage, data, uid, sessionId))
    }

    const options = Object.values(groupContext).map(option => (
        // <Button text={option['title']} icon={option['icon']}
        //     styles={page['group'] && page['group'] === option['value'] ? selectedStyle : buttonStyle}
        //     onSelect={() => onSelect(option['value'])}/>
        <Row onClick={() => onSelect(option['value'])}>
            <Icon>{option['icon']}</Icon>
            <Text>{option['title']}</Text>
            <span/>
            {group === option['value'] ? <FaCheck style={{ color: 'var(--focus-color)' }}/> : null}
        </Row>
    ))

    return (
        <Container>
            <Header>
                <Title>Group</Title>
                <Button text='Clear' onSelect={() => onSelect(null)}
                    styles={{ margin: 0, color: 'var(--text-color)', fontWeight: 'bold', fontSize: '0.7rem', backgroundColor: 'var(--secondary-color)', boxShadowColor: 'transparent' }}/>
            </Header>
            {options}
        </Container>
    )
}

export default GroupOptions